<template>
  <div class="date_wrap">
    <div class="date_input">
      <span class="input-text" style="text-indent: 0px;">
        <datepicker ref="datePicker" :id="id" :name="name" :value="value" :language="ko" :format="format" :disabled="disabled" @selected="updateDate" />
      </span>
    </div>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {ko} from 'vuejs-datepicker/dist/locale';
import moment from 'moment';

export default {
  name: 'inputDate',
  props: {
    id: "",
    name: "",
    value: "",
    disabled: false
  },
  components: { Datepicker },
  data () {
    return {
      format: "yyyy-MM-dd",
      ko: ko
    }
  },
  methods: {
    updateDate(date) {
      this.$emit('input', moment(date).format('YYYY-MM-DD'));
    }
  },
  mounted() {

  },
}
</script>

<style scoped>
  div {
        display:inline;
  }
</style>


// WEBPACK FOOTER //
// src/components/InputDate.vue